import React from 'react';

import avatar from '@assets/images/avatar.jpg';

import { AvatarProps } from './Avatar.types';
import { AvatarContainer, AvatarImage } from './Avatar.styled';

export const Avatar = ({ dimension = 350, shadow }: AvatarProps) => (
    <AvatarContainer dimension={dimension}>
      <AvatarImage
        src={avatar}
        alt="avatar"
        shadow={shadow}
        dimension={dimension}
      />
    </AvatarContainer>
  );
